
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DashboardService } from '../dashboard.service';
import { ToastMessageService } from 'src/app/toastr.service';

interface CalendarOption {
  label: string;
  value: number;
  subtitle?: string;
  isCurrent?: boolean;
}

@Component({
  selector: 'app-calendar-view',
  templateUrl: './calenderview.component.html',
  styleUrls: ['./calenderview.component.scss']
})
export class CalendarViewComponent implements OnInit {
  monthlyOptions: CalendarOption[] = [];
  quarterlyOptions: CalendarOption[] = [];
  halfYearlyOptions: CalendarOption[] = [];
  yearlyOptions: CalendarOption[] = [];
  activeTab = "monthly";
  totalPdufas: number = 0;
  ndaApplications: number = 0;
  sndaApplications: number = 0;
  priorityReviews: number = 0;
  public currentYear = new Date().getFullYear();
  private currentMonth = new Date().getMonth();
  calendarData: any[] = [];

  // Modal properties
  displayModal: boolean = false;
  selectedRowData: any = null;

  // Delete properties
  displayDeleteDialog: boolean = false;
  itemToDelete: any = null;

  // Publish properties
  displayPublishDialog: boolean = false;
  itemToPublish: any = null;

  // Edit properties (now handled by drug modal)
  designationTags: string[] = [];
  selectedDesignationTag: any = null;

  // Year selection properties
  selectedYear: number = new Date().getFullYear();
  availableYears: number[] = [];
  filteredCalendarData: any[] = [];

  publishOptions = [
    { label: 'All Publish Status', value: null },
    { label: 'Published', value: true },
    { label: 'Unpublished', value: false },
  ];

  pdufaStatusOptions = [
    { label: 'All PDUFA Status', value: null },
    { label: 'Approved', value: 'Approved' },
    { label: 'Under Review', value: 'Under Review' },
    { label: 'CRL Issued', value: 'CRL Issued' },
    { label: 'PDUFA Extension', value: 'PDUFA Extension' },
  ];

  selectedPublish: any = null;
  selectedPdufaStatus: any = null;
  selectedTherapeuticArea: any = null;
  therapeuticCategories: any[] = [];

  private selectedMonthValue: number = new Date().getMonth() + 1;
  private selectedQuarterValue: number = Math.floor(new Date().getMonth() / 3) + 1;
  private selectedHalfValue: number = Math.floor(new Date().getMonth() / 6) + 1;
  private selectedYearValue: number = new Date().getFullYear();
  private isAllRecords: boolean = false;

  constructor(
    private dashboardService: DashboardService,
    private fb: FormBuilder,
    private toastService: ToastMessageService,
  ) { }

  ngOnInit() {
    this.dashboardService.getStatistics(this.activeTab, (this.currentMonth + 1).toString(), this.currentYear.toString()).subscribe((stats) => {
      this.totalPdufas = stats?.records?.records?.length || 0;
      this.ndaApplications = stats?.nda_vs_snda?.NDA || 0;
      this.sndaApplications = stats?.nda_vs_snda?.sNDA || 0;
      this.priorityReviews = stats?.designation_counts?.['Priority Review'] || 0;
      this.calendarData = stats?.records?.records || [];
      this.initializeYearDropdown();
      // this.filterDataByYear();
      this.filteredCalendarData = this.calendarData;
    }, err => {
      console.log(err);
      this.calendarData = [];
      this.filteredCalendarData = [];
    });

    // Load designation tags for edit form
    this.dashboardService.pdufaInformation$.subscribe((res) => {
      // this.designationTags = res?.designation_tags || [];

      if (res?.designation_tags && res?.designation_tags.length > 0) {

        this.designationTags = [
          { label: 'All Designation Tags', value: null },
          ...res?.designation_tags.map(tag => ({ label: tag, value: tag })),
        ];
      }
      if (res?.therapeutic_categories && res?.therapeutic_categories.length > 0) {
        this.therapeuticCategories = [
          { label: 'All Therapeutic Categories', value: null },
          ...res?.therapeutic_categories.map(area => ({ label: area, value: area })),
        ];
      }

    });

    this.generateCalendarOptions();
  }

  selectPeriod(type: string, value: string) {
    if (type === 'monthly') {
      console.log("value", value);
      const findIndex = this.monthlyOptions.findIndex(option => option.value === parseInt(value));
      if (findIndex !== -1) {
        this.monthlyOptions.forEach(option => {
          if (option.value !== parseInt(value)) {
            option.isCurrent = false;
          }
          else {
            option.isCurrent = true;
          }
        });
      }
      if (this.monthlyOptions[findIndex].label === 'All Records') {
        this.isAllRecords = true;
        this.dashboardService.getAllStatistics().subscribe((stats) => {
          this.calendarData = stats?.records?.records || [];
          this.filteredCalendarData = this.calendarData;
          this.totalPdufas = stats?.records?.records?.length || 0;
          this.ndaApplications = stats?.nda_vs_snda?.NDA || 0;
          this.sndaApplications = stats?.nda_vs_snda?.sNDA || 0;
          this.priorityReviews = stats?.designation_counts?.['Priority Review'] || 0;
        }, err => {
          console.log(err);
          this.calendarData = [];
          this.filteredCalendarData = [];
        });
      }
      else {
        this.isAllRecords = false;
        this.selectedMonthValue = parseInt(value);
        this.dashboardService.getStatistics(this.activeTab, (value).toString(), this.currentYear.toString()).subscribe((stats) => {
          this.calendarData = stats?.records?.records || [];
          this.totalPdufas = stats?.records?.records?.length || 0;
          this.ndaApplications = stats?.nda_vs_snda?.NDA || 0;
          this.sndaApplications = stats?.nda_vs_snda?.sNDA || 0;
          this.priorityReviews = stats?.designation_counts?.['Priority Review'] || 0;
          // this.filteredCalendarData = this.calendarData.filter(item => {
          //   return item.pdufa_date && new Date(item.pdufa_date).getFullYear() === this.selectedYear;
          // });
          this.filteredCalendarData = this.calendarData;
        }, err => {
          console.log(err);
          this.calendarData = [];
          this.filteredCalendarData = [];
        });
      }
    }
    if (type === 'quarterly') {
      this.quarterlyOptions.forEach(option => {
        if ((option.value).toString() !== (value).toString()) {
          option.isCurrent = false;
        }
        else {
          option.isCurrent = true;
        }
      });
      const findIndex = this.quarterlyOptions.findIndex(option => option.value === parseInt(value));
      if (this.quarterlyOptions[findIndex].label === 'All Records') {
        this.isAllRecords = true;
        this.dashboardService.getAllStatistics().subscribe((stats) => {
          this.calendarData = stats?.records?.records || [];
          this.filteredCalendarData = this.calendarData;
          this.totalPdufas = stats?.records?.records?.length || 0;
          this.ndaApplications = stats?.nda_vs_snda?.NDA || 0;
          this.sndaApplications = stats?.nda_vs_snda?.sNDA || 0;
          this.priorityReviews = stats?.designation_counts?.['Priority Review'] || 0;
        }, err => {
          console.log(err);
          this.calendarData = [];
          this.filteredCalendarData = [];
        });
      }
      else {
        this.isAllRecords = false;
        this.selectedQuarterValue = parseInt(value);
        this.dashboardService.getStatistics(this.activeTab, "0", this.currentYear.toString(), ('Q' + value)).subscribe((stats) => {
          this.calendarData = stats?.records?.records || [];
          this.totalPdufas = stats?.records?.records?.length || 0;
          this.ndaApplications = stats?.nda_vs_snda?.NDA || 0;
          this.sndaApplications = stats?.nda_vs_snda?.sNDA || 0;
          this.priorityReviews = stats?.designation_counts?.['Priority Review'] || 0;
          // this.filteredCalendarData = this.calendarData.filter(item => {
          //   return item.pdufa_date && new Date(item.pdufa_date).getFullYear() === this.selectedYear;
          // });
          this.filteredCalendarData = this.calendarData;
        });
      }
    }
    if (type === 'halfyearly') {
      const findIndex = this.halfYearlyOptions.findIndex(option => option.value === parseInt(value));
      if (findIndex !== -1) {
        this.halfYearlyOptions.forEach(option => {
          if ((option.value).toString() !== (value).toString()) {
            option.isCurrent = false;
          }
          else {
            option.isCurrent = true;
          }
        });
      }
      if (this.halfYearlyOptions[findIndex].label === 'All Records') {
        this.isAllRecords = true;
        this.dashboardService.getAllStatistics().subscribe((stats) => {
          this.calendarData = stats?.records?.records || [];
          this.filteredCalendarData = this.calendarData;
          this.totalPdufas = stats?.records?.records?.length || 0;
          this.ndaApplications = stats?.nda_vs_snda?.NDA || 0;
          this.sndaApplications = stats?.nda_vs_snda?.sNDA || 0;
          this.priorityReviews = stats?.designation_counts?.['Priority Review'] || 0;
          this.calendarData = stats?.records?.records || [];
        });
      }
      else {
        this.isAllRecords = false;
        this.selectedHalfValue = parseInt(value);
        this.dashboardService.getStatistics(this.activeTab, (value).toString(), this.currentYear.toString(), 'h' + value).subscribe((stats) => {
          this.calendarData = stats?.records?.records || [];
          this.totalPdufas = stats?.records?.records?.length || 0;
          this.ndaApplications = stats?.nda_vs_snda?.NDA || 0;
          this.sndaApplications = stats?.nda_vs_snda?.sNDA || 0;
          this.priorityReviews = stats?.designation_counts?.['Priority Review'] || 0;
          this.calendarData = stats?.records?.records || [];
          // this.filteredCalendarData = this.calendarData.filter(item => {
          //   return item.pdufa_date && new Date(item.pdufa_date).getFullYear() === this.selectedYear;
          // });
          this.filteredCalendarData = this.calendarData;
        }, err => {
          console.log(err);
          this.calendarData = [];
          this.filteredCalendarData = [];
        });
      }
    }
    if (type === 'yearly') {
      const findIndex = this.yearlyOptions.findIndex(option => option.value === parseInt(value));
      if (findIndex !== -1) {
        this.yearlyOptions.forEach(option => {
          if ((option.value).toString() !== (value).toString()) {
            option.isCurrent = false;
          }
          else {
            option.isCurrent = true;
          }
        });
      }
      if (this.yearlyOptions[findIndex].label === 'All Records') {
        this.isAllRecords = true;
        this.dashboardService.getAllStatistics().subscribe((stats) => {
          this.calendarData = stats?.records?.records || [];
          this.filteredCalendarData = this.calendarData;
          this.totalPdufas = stats?.records?.records?.length || 0;
          this.ndaApplications = stats?.nda_vs_snda?.NDA || 0;
          this.sndaApplications = stats?.nda_vs_snda?.sNDA || 0;
          this.priorityReviews = stats?.designation_counts?.['Priority Review'] || 0;
          this.calendarData = stats?.records?.records || [];
        });
      }
      else {
        this.isAllRecords = false;
        this.selectedYearValue = parseInt(value);
        this.dashboardService.getStatistics(this.activeTab, "0", value.toString()).subscribe((stats) => {
          this.calendarData = stats?.records?.records || [];
          this.totalPdufas = stats?.records?.records?.length || 0;
          this.ndaApplications = stats?.nda_vs_snda?.NDA || 0;
          this.sndaApplications = stats?.nda_vs_snda?.sNDA || 0;
          this.priorityReviews = stats?.designation_counts?.['Priority Review'] || 0;
          this.calendarData = stats?.records?.records || [];
          // this.filteredCalendarData = this.calendarData.filter(item => {
          //   return item.pdufa_date && new Date(item.pdufa_date).getFullYear() === this.selectedYear;
          // });
          this.filteredCalendarData = this.calendarData;
        }, err => {
          console.log(err);
          this.calendarData = [];
          this.filteredCalendarData = [];
        });
      }
    }
  }

  private generateCalendarOptions() {
    this.monthlyOptions = [];
    this.quarterlyOptions = [];
    this.halfYearlyOptions = [];
    this.yearlyOptions = [];
    this.generateMonthlyOptions();
    this.generateQuarterlyOptions();
    this.generateHalfYearlyOptions();
    this.generateYearlyOptions();
  }

  private generateMonthlyOptions() {
    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December', 'All Records'
    ];

    const year = this.currentYear;

    months.forEach((month, index) => {
      this.monthlyOptions.push({
        label: month === 'All Records' ? 'All Records' : `${month} ${year}`,
        value: index + 1,
        isCurrent: index === this.currentMonth
      });
    });
    console.log(this.monthlyOptions);
  }

  private generateQuarterlyOptions() {
    const quarters = ['Q1', 'Q2', 'Q3', 'Q4', 'All Records'];
    const quarterMonths = ['Jan-Mar', 'Apr-Jun', 'Jul-Sep', 'Oct-Dec', 'All Records'];

    quarters.forEach((quarter, index) => {
      const currentQuarter = Math.floor(this.currentMonth / 3);


      this.quarterlyOptions.push({
        label: quarter === 'All Records' ? 'All Records' : `${quarter} ${this.currentYear}`,
        value: index + 1,
        subtitle: quarterMonths[index],
        isCurrent: index === currentQuarter
      });
    });
  }

  private generateHalfYearlyOptions() {
    const halves = [
      { label: 'H1', months: 'Jan-Jun' },
      { label: 'H2', months: 'Jul-Dec' },
      { label: 'All Records', months: 'All Records' },
    ];

    halves.forEach((half, index) => {
      const currentHalf = Math.floor(this.currentMonth / 6);

      this.halfYearlyOptions.push({
        label: half.label === 'All Records' ? 'All Records' : `${half.label} ${this.currentYear}`,
        value: index + 1,
        subtitle: half.months,
        isCurrent: index === currentHalf
      });
    });
  }

  private generateYearlyOptions() {
    for (let yearOffset = 0; yearOffset <= 5; yearOffset++) {
      const year = parseInt(this.currentYear.toString()) + yearOffset;

      this.yearlyOptions.push({
        label: year.toString() === '0' ? 'All Records' : year.toString(),
        value: year,
        isCurrent: yearOffset === 0
      });
    }
    this.yearlyOptions.push({
      label: 'All Records',
      value: 0,
      subtitle: 'All Records',
      isCurrent: false
    });
  }

  setTab(tab: string) {
    this.activeTab = tab;

    // this.generateCalendarOptions();
    if (this.activeTab === 'monthly') {
      this.dashboardService.getStatistics(this.activeTab, (this.currentMonth + 1).toString(), this.currentYear.toString()).subscribe((stats) => {
        this.calendarData = stats?.records?.records || [];
        this.totalPdufas = stats?.records?.records?.length || 0;
        this.ndaApplications = stats?.nda_vs_snda?.NDA || 0;
        this.sndaApplications = stats?.nda_vs_snda?.sNDA || 0;
        this.priorityReviews = stats?.designation_counts?.['Priority Review'] || 0;
        this.calendarData = stats?.records?.records || [];
        // this.filteredCalendarData = this.calendarData.filter(item => {
        //   return item.pdufa_date && new Date(item.pdufa_date).getFullYear() === this.selectedYear;
        // }, err => {
        //   console.log(err);
        //   this.calendarData = [];
        //   this.filteredCalendarData = [];
        // });
        this.filteredCalendarData = this.calendarData;
      }, err => {
        console.log(err);
        this.calendarData = [];
        this.filteredCalendarData = [];
      });
    }
    if (this.activeTab === 'quarterly') {
      const currentQuarter = Math.floor(this.currentMonth / 3);
      this.dashboardService.getStatistics(this.activeTab, "0", this.currentYear.toString(), 'Q' + (currentQuarter + 1)).subscribe((stats) => {
        this.calendarData = stats?.records?.records || [];
        this.totalPdufas = stats?.records?.records?.length || 0;
        this.ndaApplications = stats?.nda_vs_snda?.NDA || 0;
        this.sndaApplications = stats?.nda_vs_snda?.sNDA || 0;
        this.priorityReviews = stats?.designation_counts?.['Priority Review'] || 0;
        this.calendarData = stats?.records?.records || [];
        // this.filteredCalendarData = this.calendarData.filter(item => {
        //   return item.pdufa_date && new Date(item.pdufa_date).getFullYear() === this.selectedYear;
        // }, err => {
        //   console.log(err);
        //   this.calendarData = [];
        //   this.filteredCalendarData = [];
        // });
        this.filteredCalendarData = this.calendarData;
      });
    }
    if (this.activeTab === 'halfyearly') {
      const currentHalf = Math.floor(this.currentMonth / 6);
      this.dashboardService.getStatistics(this.activeTab, "0", this.currentYear.toString(), 'h' + (currentHalf + 1)).subscribe((stats) => {
        this.calendarData = stats?.records?.records || [];
        this.totalPdufas = stats?.records?.records?.length || 0;
        this.ndaApplications = stats?.nda_vs_snda?.NDA || 0;
        this.sndaApplications = stats?.nda_vs_snda?.sNDA || 0;
        this.priorityReviews = stats?.designation_counts?.['Priority Review'] || 0;
        this.calendarData = stats?.records?.records || [];
        // this.filteredCalendarData = this.calendarData.filter(item => {
        //   return item.pdufa_date && new Date(item.pdufa_date).getFullYear() === this.selectedYear;
        // }, err => {
        //   console.log(err);
        //   this.calendarData = [];
        //   this.filteredCalendarData = [];
        // });
        this.filteredCalendarData = this.calendarData;
      }, err => {
        console.log(err);
        this.calendarData = [];
        this.filteredCalendarData = [];
      });
    }
    if (this.activeTab === 'yearly') {
      this.dashboardService.getStatistics(this.activeTab, "0", this.currentYear.toString()).subscribe((stats) => {
        this.calendarData = stats?.records?.records || [];
        this.totalPdufas = stats?.records?.records?.length || 0;
        this.ndaApplications = stats?.nda_vs_snda?.NDA || 0;
        this.sndaApplications = stats?.nda_vs_snda?.sNDA || 0;
        this.priorityReviews = stats?.designation_counts?.['Priority Review'] || 0;
        this.calendarData = stats?.records?.records || [];
        // this.filteredCalendarData = this.calendarData.filter(item => {
        //   return item.pdufa_date && new Date(item.pdufa_date).getFullYear() === this.selectedYear;
        // }, err => {
        //   console.log(err);
        //   this.calendarData = [];
        //   this.filteredCalendarData = [];
        // });
        this.filteredCalendarData = this.calendarData;
      });
    }
  }

  // Method to show modal with row data
  showModal(rowData: any) {
    this.selectedRowData = rowData;
    this.displayModal = true;
  }

  // Method to hide modal
  hideModal() {
    this.displayModal = false;
    this.selectedRowData = null;
  }

  // Initialize year dropdown with available years from data
  private initializeYearDropdown() {
    const years = new Set<number>();

    // Extract years from calendar data
    this.calendarData.forEach(item => {
      if (item.pdufa_date) {
        const date = new Date(item.pdufa_date);
        if (!isNaN(date.getTime())) {
          years.add(date.getFullYear());
        }
      }
    });

    // Add current year and next few years if not present
    const currentYear = new Date().getFullYear();
    years.add(currentYear - 2);
    years.add(currentYear - 1);

    years.add(currentYear);
    years.add(currentYear + 1);
    years.add(currentYear + 2);

    this.availableYears = Array.from(years).sort((a, b) => b - a); // Sort descending
  }

  // Filter data by selected year
  private filterDataByYear() {
    if (!this.calendarData || this.calendarData.length === 0) {
      this.filteredCalendarData = [];
      return;
    }

    this.filteredCalendarData = this.calendarData.filter(item => {
      if (!item.pdufa_date) return false;

      const date = new Date(item.pdufa_date);
      if (isNaN(date.getTime())) return false;

      return date.getFullYear() === this.selectedYear;
    });
  }

  // Handle year selection change
  onYearChange() {
    this.generateCalendarOptions();
    if (this.activeTab === 'monthly') {
      this.dashboardService.getStatistics(this.activeTab, (this.currentMonth + 1).toString(), this.currentYear.toString()).subscribe((stats) => {
        this.calendarData = stats?.records?.records || [];
        this.totalPdufas = stats?.records?.records?.length || 0;
        this.ndaApplications = stats?.nda_vs_snda?.NDA || 0;
        this.sndaApplications = stats?.nda_vs_snda?.sNDA || 0;
        this.priorityReviews = stats?.designation_counts?.['Priority Review'] || 0;
        this.calendarData = stats?.records?.records || [];
        // this.filteredCalendarData = this.calendarData.filter(item => {
        //   return item.pdufa_date && new Date(item.pdufa_date).getFullYear() === this.selectedYear;
        // }, err => {
        //   console.log(err);
        //   this.calendarData = [];
        //   this.filteredCalendarData = [];
        // });
        this.filteredCalendarData = this.calendarData;
      }, err => {
        console.log(err);
        this.calendarData = [];
        this.filteredCalendarData = [];
      });
    }
    if (this.activeTab === 'quarterly') {
      const currentQuarter = Math.floor(this.currentMonth / 3);
      this.dashboardService.getStatistics(this.activeTab, "0", this.currentYear.toString(), 'Q' + (currentQuarter + 1)).subscribe((stats) => {
        this.calendarData = stats?.records?.records || [];
        this.totalPdufas = stats?.records?.records?.length || 0;
        this.ndaApplications = stats?.nda_vs_snda?.NDA || 0;
        this.sndaApplications = stats?.nda_vs_snda?.sNDA || 0;
        this.priorityReviews = stats?.designation_counts?.['Priority Review'] || 0;
        this.calendarData = stats?.records?.records || [];
        // this.filteredCalendarData = this.calendarData.filter(item => {
        //   return item.pdufa_date && new Date(item.pdufa_date).getFullYear() === this.selectedYear;
        // }, err => {
        //   console.log(err);
        //   this.calendarData = [];
        //   this.filteredCalendarData = [];
        // });
        this.filteredCalendarData = this.calendarData;
      });
    }
    if (this.activeTab === 'halfyearly') {
      const currentHalf = Math.floor(this.currentMonth / 6);
      this.dashboardService.getStatistics(this.activeTab, "0", this.currentYear.toString(), 'h' + (currentHalf + 1)).subscribe((stats) => {
        this.calendarData = stats?.records?.records || [];
        this.totalPdufas = stats?.records?.records?.length || 0;
        this.ndaApplications = stats?.nda_vs_snda?.NDA || 0;
        this.sndaApplications = stats?.nda_vs_snda?.sNDA || 0;
        this.priorityReviews = stats?.designation_counts?.['Priority Review'] || 0;
        this.calendarData = stats?.records?.records || [];
        // this.filteredCalendarData = this.calendarData.filter(item => {
        //   return item.pdufa_date && new Date(item.pdufa_date).getFullYear() === this.selectedYear;
        // }, err => {
        //   console.log(err);
        //   this.calendarData = [];
        //   this.filteredCalendarData = [];
        // });
        this.filteredCalendarData = this.calendarData;
      });
    }
    if (this.activeTab === 'yearly') {
      this.dashboardService.getStatistics(this.activeTab, "0", this.currentYear.toString()).subscribe((stats) => {
        this.calendarData = stats?.records?.records || [];
        this.totalPdufas = stats?.records?.records?.length || 0;
        this.ndaApplications = stats?.nda_vs_snda?.NDA || 0;
        this.sndaApplications = stats?.nda_vs_snda?.sNDA || 0;
        this.priorityReviews = stats?.designation_counts?.['Priority Review'] || 0;
        this.calendarData = stats?.records?.records || [];
        // this.filteredCalendarData = this.calendarData.filter(item => {
        //   return item.pdufa_date && new Date(item.pdufa_date).getFullYear() === this.selectedYear;
        // }, err => {
        //   console.log(err);
        //   this.calendarData = [];
        //   this.filteredCalendarData = [];
        // });
        this.filteredCalendarData = this.calendarData;
      });
    }
    // this.filterDataByYear();
    // this.updateStatistics();
  }
  addNewEntry() {
    // Clear all filters before starting new entry flow
    this.dashboardService.resetFilters();
    this.dashboardService.selectPeriod(this.activeTab, (this.currentMonth + 1).toString());
  }

  // Delete functionality
  confirmDelete(item: any) {
    this.itemToDelete = item;
    this.displayDeleteDialog = true;
  }

  hideDeleteDialog() {
    this.displayDeleteDialog = false;
    this.itemToDelete = null;
  }

  deleteItem() {
    console.log("this.itemToDelete", this.itemToDelete)
    console.log("this.itemToDelete.id", this.itemToDelete._id)
    if (this.itemToDelete && this.itemToDelete._id) {
      this.dashboardService.deleteDrug(this.itemToDelete._id).subscribe({
        next: (response) => {
          console.log('Item deleted successfully:', response);
          this.hideDeleteDialog();
          this.refreshData();
          // Show success message (you can add toast notification here)
        },
        error: (error) => {
          console.error('Error deleting item:', error);
          // Show error message (you can add toast notification here)
        }
      });
    }
  }

  private refreshData() {
    if (this.isAllRecords) {
      this.dashboardService.getAllStatistics().subscribe((stats) => {
        this.handleResponse(stats);
      }, this.handleError.bind(this));
      return;
    }

    if (this.activeTab === 'monthly') {
      this.dashboardService
        .getStatistics(this.activeTab, this.selectedMonthValue.toString(), this.currentYear.toString())
        .subscribe((stats) => { this.handleResponse(stats); }, this.handleError.bind(this));
    }

    if (this.activeTab === 'quarterly') {
      this.dashboardService
        .getStatistics(this.activeTab, "0", this.currentYear.toString(), 'Q' + this.selectedQuarterValue)
        .subscribe((stats) => { this.handleResponse(stats); }, this.handleError.bind(this));
    }

    if (this.activeTab === 'halfyearly') {
      this.dashboardService
        .getStatistics(this.activeTab, "0", this.currentYear.toString(), 'h' + this.selectedHalfValue)
        .subscribe((stats) => { this.handleResponse(stats); }, this.handleError.bind(this));
    }

    if (this.activeTab === 'yearly') {
      this.dashboardService
        .getStatistics(this.activeTab, "0", this.selectedYearValue.toString())
        .subscribe((stats) => { this.handleResponse(stats); }, this.handleError.bind(this));
    }
  }

  private handleResponse(stats: any) {
    this.totalPdufas = stats?.records?.records?.length || 0;
    this.ndaApplications = stats?.nda_vs_snda?.NDA || 0;
    this.sndaApplications = stats?.nda_vs_snda?.sNDA || 0;
    this.priorityReviews = stats?.designation_counts?.['Priority Review'] || 0;
    this.calendarData = stats?.records?.records || [];
    this.filteredCalendarData = this.calendarData;
  }

  private handleError(error: any) {
    console.log(error);
    this.calendarData = [];
    this.filteredCalendarData = [];
  }

  editItem(item: any) {
    this.dashboardService.startEditFlow(item);
  }
  statusChange(item: any, status: any) {
    console.log("item", item);
    this.itemToPublish = item;
    this.displayPublishDialog = true;
  }

  confirmPublishChange() {
    if (this.itemToPublish) {
      const payload = {
        _id: {
          "$oid": this.itemToPublish._id
        },
        publish: this.itemToPublish.publish === true || this.itemToPublish.publish === 'true' ? false : true
      };

      this.dashboardService.updateDrugPublish(payload).subscribe((res) => {
        console.log("res", res);
        this.refreshData();
        this.toastService.success("Status changed successfully");
        this.hidePublishDialog();
      }, err => {
        console.log(err);
        this.toastService.error("Failed to change status");
      });
    }
  }

  hidePublishDialog() {
    this.displayPublishDialog = false;
    this.itemToPublish = null;
  }

  onFilterChange() {
    this.filterDataByPublish();
  }

  onPdufaStatusChange() {
    this.filterDataByPdufaStatus();
  }
  filterDataByPdufaStatus() {
    if (this.selectedPdufaStatus === null) {
      this.filteredCalendarData = this.calendarData;
      return;
    }
    this.filteredCalendarData = this.calendarData.filter(item => {
      return item.pdufa_status === this.selectedPdufaStatus;
    });
  }

  filterDataByPublish() {
    console.log("this.selectedPublish", this.selectedPublish);
    if (this.selectedPublish === null) {
      this.filteredCalendarData = this.calendarData;
      return;
    }
    this.filteredCalendarData = this.calendarData.filter(item => {
      return item.publish === this.selectedPublish;
    });
  }

  getPdufaStatusClass(status: string): string {
    if (!status) return 'status-na';

    switch (status.toLowerCase()) {
      case 'approved':
        return 'status-approved';
      case 'under review':
        return 'status-under-review';
      case 'crl issued':
        return 'status-crl-issued';
      case 'pdufa extension':
        return 'status-pdufa-extension';
      default:
        return 'status-na';
    }
  }
  onDesignationTagChange() {
    this.filterDataByDesignationTag();
  }
  filterDataByDesignationTag() {
    if (this.selectedDesignationTag === null) {
      this.filteredCalendarData = this.calendarData;
      return;
    }
    this.filteredCalendarData = this.calendarData.filter(item => {
      return item.designation_tags.includes(this.selectedDesignationTag);
    });
  }
  onTherapeuticCategoryChange() {
    this.filterDataByTherapeuticCategory();
  }
  filterDataByTherapeuticCategory() {
    if (this.selectedTherapeuticArea === null) {
      this.filteredCalendarData = this.calendarData;
      return;
    }
    this.filteredCalendarData = this.calendarData.filter(item => {
      return item.therapeutic_categories.includes(this.selectedTherapeuticArea);
    });
  }

}
